import {Article, ArticleIntro} from "../model/Article";
import {Page, PageDescription} from "../model/Page";

export interface Api {
    getArticleIntros(limit: number, offset: number): Promise<ArticleIntro[]>;
    getArticle(id: string): Promise<Article | undefined>;

    getPageDescriptions(): Promise<PageDescription[]>
    getPage(id: string): Promise<Page | undefined>
}

export class FakeApi implements Api{
    async getArticle(id: string): Promise<Article | undefined> {
        await sleep(1000);
        return this.makeArticle(id)
    }

    private makeArticle(id: string): Article {
        return {
            id: id,
            title: `${id} Большое обновление Bill-Splitter (Дели Счет)`,
            introText: `${id} За последний год мне надоело выслушивать жалобы друзей на недостаточно понятное приложение Money-Splitter. Приложение то очень полезное, но, чтобы им начать пользоваться — было нужно сидеть и разбираться как оно работает. Поэтому я решил полностью переделать UI, сделать его как можно более понятным для новичков и, в дополнение, сделать его удобным для использования на смартфоне.`,
            remainingText: '<p style="color: #61dafb">За последний год мне надоело выслушивать жалобы друзей на недостаточно понятное приложение Money-Splitter.</p> <strong>Приложение то очень полезное</strong>, но, чтобы им начать пользоваться — было нужно сидеть и разбираться как оно работает. Поэтому я решил полностью переделать UI, сделать его как можно более понятным для новичков и, в дополнение, сделать его удобным для использования на смартфоне.',
            publishTimeMillisUtc: new Date().getTime()
        }
    }

    async getArticleIntros(limit: number, offset: number): Promise<ArticleIntro[]> {
        await sleep(2000);
        const result: ArticleIntro[] = []
        for (let i = offset; i < limit + offset; i++) {
            result.push(this.makeArticle(i.toString()))
        }
        return result
    }

    async getPageDescriptions(): Promise<PageDescription[]> {
        await sleep(1500);
        return [
            {
                id: "about-me",
                title: "About Me"
            },
            {
                id: "another-page",
                title: "Some Cool Page"
            }
        ]
    }
    async getPage(id: string): Promise<Page | undefined> {
        await sleep(2000);
        if (id === 'about-me') {
            return {
                id: "about-me",
                title: "About Me",
                publishTimeMillisUtc: new Date().getTime(),
                text: "About Me За последний год мне надоело выслушивать жалобы друзей на недостаточно понятное приложение Money-Splitter. Приложение то очень полезное, но, чтобы им начать пользоваться — было нужно сидеть и разбираться как оно работает. Поэтому я решил полностью переделать UI, сделать его как можно более понятным для новичков и, в дополнение, сделать его удобным для использования на смартфоне."
            }
        } else if (id === 'another-page') {
            return {
                id: "another-page",
                title: "Some Cool Page",
                publishTimeMillisUtc: new Date().getTime(),
                text: "Some Cool Page За последний год мне надоело выслушивать жалобы друзей на недостаточно понятное приложение Money-Splitter. Приложение то очень полезное, но, чтобы им начать пользоваться — было нужно сидеть и разбираться как оно работает. Поэтому я решил полностью переделать UI, сделать его как можно более понятным для новичков и, в дополнение, сделать его удобным для использования на смартфоне."
            }
        } else if (id === 'logged-in') {
            return {
                id: "logged-in",
                title: "Logged in",
                publishTimeMillisUtc: new Date().getTime(),
                text: "Some Cool Page За последний год мне надоело выслушивать жалобы друзей на недостаточно понятное приложение Money-Splitter. Приложение то очень полезное, но, чтобы им начать пользоваться — было нужно сидеть и разбираться как оно работает. Поэтому я решил полностью переделать UI, сделать его как можно более понятным для новичков и, в дополнение, сделать его удобным для использования на смартфоне."
            }
        } else {
            return undefined
        }
    }
}

export function getApi(): Api {
    return new FakeApi()
}

const sleep = (ms: number) => new Promise(
    resolve => setTimeout(resolve, ms)
);

export function getApiUrl(): string {
    if (window.location.hostname === 'localhost') {
        return `https://${process.env.REACT_APP_API_DOMAIN}`
    } else {
        return `https://api.${window.location.hostname.replaceAll('www.', '')}`
    }
}

export function getAuthUrl(): string {
    if (window.location.hostname === 'localhost') {
        return `https://${process.env.REACT_APP_AUTH0_DOMAIN}`
    } else {
        return `https://account.${window.location.hostname.replaceAll('www.', '')}`
    }
}

export function getAuthClientId(): string {
    if (window.location.hostname === 'localhost') {
        return `${process.env.REACT_APP_AUTH0_CLIENT_ID}`
    } else {
        // todo configure better
        if (window.location.hostname.replaceAll('www.', '') === 'dev.zavediaev.com') {
            return '10ioqkj37pdc7gi5sjlji8jmh9'
        } else {
            return '3tlq2flubtjm1mmp0vg51jpu9i'
        }
    }
}